import PropTypes from "prop-types";
import React from "react";

import { FlatList } from "react-native";

import DependencyItem from "./DependencyItem";

export default class DependencyList extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  renderItem = ({ fullName, dependent }) => {
    const { onSelect } = this.props;

    return (
      <DependencyItem
        fullName={fullName}
        dependent={dependent}
        onSelect={() => {
          onSelect(dependent);
        }}
      />
    );
  }

  render() {
    const { data } = this.props;

    return (
      <FlatList
        data={data}
        keyExtractor={item => item.dependent}
        renderItem={({ item }) => this.renderItem(item)}
      />
    );
  }
}
